'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
